import React, { useState, useEffect } from "react";
import { usePrevious } from "../../components/sports/glo/brackets/common";

// generic 
import { ScoreContainer as GenScoreContainer } from "components/sports/glo/scores/generic";

// sport related
import { ScoreContainer as BdmScoreContainer } from "components/sports/glo/scores/bdm";
import { ScoreContainer as ClbScoreContainer } from "components/sports/glo/scores/clb";
import { ScoreContainer as CslScoreContainer } from "components/sports/glo/scores/csl";
import { ScoreContainer as FenScoreContainer } from "components/sports/glo/scores/fen";
import { ScoreContainer as JudScoreContainer } from "components/sports/glo/scores/jud";
import { ScoreContainer as SrfScoreContainer } from "components/sports/glo/scores/srf";
import { ScoreContainer as TenScoreContainer } from "components/sports/glo/scores/ten";
import { ScoreContainer as TteScoreContainer } from "components/sports/glo/scores/tte";
import { ScoreContainer as BoxScoreContainer } from "components/sports/glo/scores/box";
import { ScoreContainer as KikScoreContainer } from "components/sports/glo/scores/kik";
import { ScoreContainer as MtiScoreContainer } from "components/sports/glo/scores/mti";
import { ScoreContainer as KteScoreContainer } from "components/sports/glo/scores/kte";
import { ScoreContainer as FblScoreContainer } from "components/sports/glo/scores/fbl";
import { ScoreContainer as TkwScoreContainer } from "components/sports/glo/scores/tkw";
import { ScoreContainer as BkgScoreContainer } from "components/sports/glo/scores/bkg";
import { ScoreContainer as WpoScoreContainer } from "components/sports/glo/scores/wpo";
import { ScoreContainer as WreScoreContainer } from "components/sports/glo/scores/wre";


export function Score(props) {

  const { discipline, matchHasIrm, resultJson, screen, competitorPos } = props
  const resultObj = resultJson ? JSON.parse(resultJson) : {};
  const [isLoading, setLoading] = useState(false);
  const result = resultObj?.result;
  const prevResult = usePrevious({ result });
  function loadingTime() {
    return new Promise((resolve) => setTimeout(resolve, 4000));
  }

  useEffect(() => {
    if (isLoading) {
      loadingTime().then(() => {
        setLoading(false);
      });
    }
  }, [isLoading]);


  useEffect(() => {
    if (prevResult && (prevResult !== result)) {
      setLoading(true)
    }
  }, [result])

  const ScoreContainer = getScoreContainer(discipline)

  return (
    <ScoreContainer resultObj={resultObj} matchHasIrm={matchHasIrm} screen={screen} competitorPos={competitorPos} />
  )
}

const getScoreContainer = (discipline) => {
  switch (discipline) {
    case 'BDM':
      return BdmScoreContainer
    case 'BOX':
      return BoxScoreContainer
    case 'BKG':
      return BkgScoreContainer
    case 'CLB':
      return ClbScoreContainer
    case 'CSL':
      return CslScoreContainer
    case 'FBB':
    case 'FBL':
      return FblScoreContainer
    case 'FEN':
      return FenScoreContainer
    case 'JUD':
      return JudScoreContainer
    case 'KTE':
      return KteScoreContainer
    case 'SRF':
      return SrfScoreContainer
    case 'WTE':
    case 'TEN':
      return TenScoreContainer
    case 'TKW':
      return TkwScoreContainer
    case 'TTE':
      return TteScoreContainer
    case 'WRE':
      return WreScoreContainer
    case 'WPO':
      return WpoScoreContainer
    case 'KIK':
      return KikScoreContainer
    case 'MTI':
      return MtiScoreContainer
    default:
      return GenScoreContainer
  }
}